var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"pt-25vh md:pt-30vh md:mb-10 pt-32 min-h-screen"},[_c('div',{staticClass:"container"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }